const Config = {
  BASE_NAME: "PROD"
};

export default Config;
